// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CallTranscript_wrapper__1K2Re","chatDisplayWrapper":"CallTranscript_chatDisplayWrapper__2dvOh"};